import { Form, Formik } from 'formik';
import React, { useEffect, useState } from 'react';
import { IoIosClose } from 'react-icons/io';
import { Button, Modal, TextField } from 'src/components';
import ImageUploadWithPreview from 'src/components/image-upload-with-preview';
import LogoUploadWithPreview from 'src/components/logo-upload-with-preview';
import Service from 'src/setup/network';
import { toastAlert } from 'src/utils/toastAlert';
import * as Yup from 'yup';

const FORM_VALIDATION = Yup.object().shape({
  name: Yup.string()
    .min(2, 'Full Name must be at least 3 characters long')
    .required('Full Name is required'),
  image: Yup.mixed().when('showImageSection', {
    is: true,
    then: Yup.mixed().required('Upload Qr Code'),
  }),
});

interface IProps {
  handleModal?: any;
  showModal?: any;
  qrEditData?: any;
  fetchData?: any;
  qrEdit?: any;
  qrData?: any;
}

const AddPayment: React.FC<IProps> = ({
  handleModal,
  showModal,
  qrEditData,
  fetchData,
  qrEdit,
  qrData,
}) => {
  const [previewImage, setPreviewImage] = React.useState<any>(
    qrEditData?.image ? qrEditData?.image : ''
  );
  const [previewLogo, setPreviewLogo] = React.useState<any>(
    qrEditData ? qrEditData?.logo : ''
  );
  const [isHiddenImage, setIsHiddenImage] = useState(false);
  const [isHiddenLogo, setIsHiddenLogo] = useState(false);
  const [showImageSection, setShowImageSection] = useState(false);
  const [imageQr, setImageQr] = useState('');

  const onImageClick = () => {
    setIsHiddenImage(!isHiddenImage);
  };

  const onLogoClick = () => {
    setIsHiddenLogo(!isHiddenLogo);
  };

  const initValues = {
    name: qrEditData ? (qrEditData.name as any) : '',
    image: qrEditData ? qrEditData.image : null,
    logo: qrEditData ? (qrEditData.logo as any) : '',
    showImageSection: false, // added this field to track the visibility of the image section
  };

  const handleSubmitQr = async (values: any, { resetForm }: any) => {
    const payload = {
      name: values?.name,
      logo: values?.logo,
      image: showImageSection ? values?.image : previewImage,
      id: qrEditData ? qrEditData?.id : '',
      needsQr: showImageSection,
    };

    try {
      await Service.post('/settings/paymentMethod', payload);
      handleModal();

      fetchData();
      toastAlert('success', `Qrs ${values?.name} is successfully created`);
      resetForm();
      setPreviewLogo(null); // Update the state for logo
      setPreviewImage(null); // Update the state for logo
      setIsHiddenLogo(false);
      setIsHiddenImage(false);
    } catch (err: any) {
      toastAlert('error', err?.response?.data?.message);
    }
  };

  useEffect(() => {
    if (qrEditData?.image) {
      setShowImageSection(true);
    } else {
      setShowImageSection(false);
    }

    setPreviewImage(qrEditData?.image ? qrEditData?.image : '');
    setPreviewLogo(qrEditData ? qrEditData?.logo : '');
  }, [qrEditData]);

  useEffect(() => {
    setImageQr(qrEditData ? (qrEditData.logo as any) : showImageSection && '');
  }, [showImageSection]);
  return (
    <div>
      {showModal && (
        <Modal title={qrEditData ? 'Edit Qr' : 'Add Qr'} onClick={handleModal}>
          <div className="mx-5 mt-4">
            <Formik
              initialValues={initValues}
              validateOnMount
              validationSchema={FORM_VALIDATION}
              onSubmit={handleSubmitQr}
            >
              {({ isValid, isSubmitting, setFieldValue }) => (
                <Form>
                  <div>
                    <div className="mt-5">
                      <TextField
                        isdisable={qrEditData && !qrEditData?.isEditable}
                        name="name"
                        label={'Name'}
                        type="text"
                        // defaultValue={qrEditData ? qrEditData?.name : ''}
                      />
                    </div>
                    {/* logo */}
                    <div className="mt-5  z-100">
                      <LogoUploadWithPreview
                        label={previewLogo ? 'Logo' : 'Upload Logo'}
                        previewImage={previewLogo}
                        hideCross={!qrEditData?.isEditable}
                        setPreviewImage={setPreviewLogo}
                        setFieldValue={setFieldValue}
                      />
                    </div>{' '}
                    {/* image or qr */}
                    {qrEditData?.isEditable && (
                      <div className="flex items-center  my-2">
                        <label
                          className="text-text-black text-sm inline-block pl-[0.15rem] hover:cursor-pointer"
                          htmlFor="flexSwitchCheckDefault"
                        >
                          Have A Qr Code
                        </label>
                        <input
                          className="ml-2 mt-[0.3rem] h-2.5 w-7 appearance-none rounded-[0.4375rem] bg-light-gray before:pointer-events-none 
                        before:absolute before:h-2.5 before:w-3.5 before:rounded-full before:bg-primary  before:content-[''] 
                        after:absolute after:z-[2] after:-mt-[0.1875rem] after:h-4 after:w-4 after:rounded-full after:border-none after:bg-light-grey 
                        after:shadow-[0_0px_3px_0_rgb(0_0_0_/_7%),_0_2px_2px_0_rgb(0_0_0_/_4%)] after:transition-[background-color_0.2s,transform_0.2s] 
                        after:content-[''] checked:bg-primary checked:after:absolute checked:after:z-[2] checked:after:-mt-[3px] checked:after:ml-[1.0625rem] 
                        checked:after:h-4 checked:after:w-4 checked:after:rounded-full checked:after:border-none checked:after:bg-primary 
                        checked:after:shadow-[0_3px_1px_-2px_rgba(0,0,0,0.2),_0_2px_2px_0_rgba(0,0,0,0.14),_0_1px_5px_0_rgba(0,0,0,0.12)] 
                        checked:after:transition-[background-color_0.2s,transform_0.2s] checked:after:content-[''] hover:cursor-pointer f
                        ocus:outline-none focus:ring-0 focus:before:scale-100 focus:before:opacity-[0.12] focus:before:shadow-[3px_-1px_0px_12px_rgba(0,0,0,0.6)] 
                        focus:before:transition-[box-shadow_0.2s,transform_0.2s] focus:after:absolute focus:after:z-[1] focus:after:block focus:after:h-4 
                        focus:after:w-4 focus:after:rounded-full focus:after:content-[''] checked:focus:border-primary checked:focus:bg-primary 
                        checked:focus:before:ml-[1.0625rem] checked:focus:before:scale-100 checked:focus:before:shadow-[3px_-1px_0px_10px_#3b71ca] 
                        checked:focus:before:transition-[box-shadow_0.2s,transform_0.2s] dark:bg-neutral-600 dark:after:bg-neutral-400 dark:checked:bg-primary
                      dark:checked:after:bg-primary dark:focus:before:shadow-[3px_-1px_0px_10px_rgba(255,255,255,0.4)] 
                      dark:checked:focus:before:shadow-[3px_-1px_0px_10px_#3b71ca]"
                          type="checkbox"
                          role="switch"
                          onChange={(e) => {
                            setFieldValue('showImageSection', e.target.checked);
                            setShowImageSection(e.target.checked);
                          }}
                          id="flexSwitchCheckDefault"
                          checked={
                            showImageSection ||
                            (showImageSection && qrEditData?.needsQr)
                          }
                        />
                      </div>
                    )}
                    {(showImageSection ||
                      (!qrEditData?.isEditable && qrEditData?.needsQr)) && (
                      <div className="mt-5  z-100">
                        <ImageUploadWithPreview
                          label={previewImage ? 'Qr Code' : 'Upload QR'}
                          previewImage={previewImage}
                          setPreviewImage={setPreviewImage}
                          setFieldValue={setFieldValue}
                          required="true"
                        />
                      </div>
                    )}
                  </div>

                  <div className="flex items-center justify-end my-2">
                    <Button
                      text={qrEditData ? 'Update Payment' : ' Add Payment'}
                      variant="primary"
                      isSubmitting={isSubmitting}
                      isValid={isValid}
                      disabled={
                        showImageSection &&
                        (isHiddenImage || previewImage === '')
                      }
                    />
                  </div>
                </Form>
              )}
            </Formik>
          </div>
        </Modal>
      )}
    </div>
  );
};

export default React.memo(AddPayment);
